"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var mobx_1 = require("mobx");
var ui_1 = require("@vidazoo/ui");
var moment = require("moment");
var index_1 = require("./index");
var logsAPI_1 = require("../api/logsAPI");
var lib_1 = require("../../lib");
var _ = require("lodash");
var LogsStore = /** @class */ (function (_super) {
    tslib_1.__extends(LogsStore, _super);
    function LogsStore(notificationsStore, exportToCsvService, filter, playerAction, prepareItems, logItemType) {
        var _this = _super.call(this, notificationsStore, ["name", "date", "pageUrl", "request", "tagId", "playerId", "campaign", "url"], "log", "name") || this;
        _this.exportToCsvService = exportToCsvService;
        _this.getItems = function () {
            return;
        };
        _this.downloadCSV = function () {
            _this.exportToCsvService.exportLogs(_this.items);
        };
        _this.generateLink = function (playerId, req, cam) {
            var request = JSON.parse(req);
            var campaign = JSON.parse(cam);
            var body = _this.generateBody(request);
            var headers = _this.generateHeaders(request);
            var raw = {
                uid: campaign.params.userId,
                pid: playerId,
                bd: body,
                hd: headers,
            };
            var params = lib_1.URLQueryParams.stringify(raw);
            window.open(window.location.origin + "/ad-server-tester?" + params);
        };
        _this.generateHeaders = function (request) {
            var headers = [];
            if (request.originalHeaders) {
                (request.originalHeaders["x-forwarded-for"]) && headers.push({
                    key: "X-Forwarded-For",
                    value: request.originalHeaders["x-forwarded-for"],
                    assignedValue: true
                });
                (request.originalHeaders["user-agent"]) && headers.push({
                    key: "User-Agent",
                    value: request.originalHeaders["user-agent"],
                    assignedValue: true
                });
                (request.originalHeaders.origin) && headers.push({
                    key: "Origin",
                    value: request.originalHeaders.origin,
                    assignedValue: false
                });
                (request.originalHeaders["content-type"]) && headers.push({
                    key: "Content-Type",
                    value: request.originalHeaders["content-type"],
                    assignedValue: false
                });
            }
            (request.referrer) && headers.push({ key: "Referer", value: request.referrer, assignedValue: false });
            return headers;
        };
        _this.generateBody = function (request) {
            var body = [];
            body.push({ key: "cacheNew", value: true }, { key: "vidazooDebug", value: true });
            if (request.originalQuery) {
                (request.originalQuery.url) && body.push({ key: "url", value: request.originalQuery.url });
            }
            return body;
        };
        _this.setHeaders = function () {
            var omittedKeys = ["date", "counter", "_id", "ua", "xml", "usp", "scenarioId", "isAmp", "requestType", "version", "protocol", "id", "exchange", "urlMacros"];
            if (_this.filteredItems.length) {
                _this.itemKeys = Object.keys(_this.filteredItems[0]);
                _.remove(_this.itemKeys, function (key) { return omittedKeys.includes(key); });
                _this.itemKeys.unshift("date");
                _this.playerAction && _this.itemKeys.push("actions");
                _this.headers = _this.itemKeys.map(function (key) {
                    return {
                        label: key,
                        sortBy: key,
                        searchKey: key
                    };
                });
            }
        };
        _this.onItemsPrepare = function () {
            if (_this.prepareItems) {
                _this.items = _this.prepareItems(_this.items);
            }
        };
        _this.reset();
        _this.filter = filter;
        _this.playerAction = playerAction;
        _this.prepareItems = prepareItems;
        _this.logItemType = logItemType;
        return _this;
    }
    LogsStore.prototype.reset = function (sort) {
        if (sort === void 0) { sort = "name"; }
        this.search = "";
        this.sortDirection = ui_1.SortDirection.ASC;
        this.headers = [];
        this.itemKeys = [];
        this.fromDate = moment().utc().startOf("hour").subtract("2", "hours");
        this.toDate = moment().utc().subtract("hour");
    };
    LogsStore.prototype.getItemsById = function (id) {
        var _this = this;
        this.isLoading = true;
        this.resetSearchQueries();
        logsAPI_1.default.getLogs(id, this.fromDate, this.toDate, this.search, this.filter, this.logItemType)
            .then(mobx_1.action(function (res) {
            _this.onLoadItemsSuccess(res);
            _this.onItemsPrepare();
            _this.setHeaders();
        }))
            .catch(function (err) { return _this.onLoadItemsError(err); });
    };
    LogsStore.prototype.onDateChange = function (from, to) {
        this.fromDate = from;
        this.toDate = to;
    };
    LogsStore.prototype.setSearch = function (value) {
        this.search = value;
    };
    tslib_1.__decorate([
        mobx_1.observable
    ], LogsStore.prototype, "fromDate", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], LogsStore.prototype, "toDate", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], LogsStore.prototype, "search", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], LogsStore.prototype, "results", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], LogsStore.prototype, "itemKeys", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], LogsStore.prototype, "headers", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], LogsStore.prototype, "reset", null);
    tslib_1.__decorate([
        mobx_1.action
    ], LogsStore.prototype, "getItemsById", null);
    tslib_1.__decorate([
        mobx_1.action
    ], LogsStore.prototype, "onDateChange", null);
    tslib_1.__decorate([
        mobx_1.action
    ], LogsStore.prototype, "setSearch", null);
    tslib_1.__decorate([
        mobx_1.action
    ], LogsStore.prototype, "downloadCSV", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], LogsStore.prototype, "generateLink", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], LogsStore.prototype, "onItemsPrepare", void 0);
    return LogsStore;
}(index_1.BaseListStore));
exports.default = LogsStore;
